(() => {
  const ids = [48729213632754, 48730857701618];
  const qualifyingIds = [7736524964082,7743022498034,7743023382770,7867532804338,7867533230322,7868368257266,8442214285554,8442214809842,8632851759346];
  const handles = ['bagel-blast-seasoning', 'steak-seasoning'];
  const root = window.Shopify?.routes?.root || '/';
  const words = window.stuGiftStrings;
  const marked = item => ids.includes(Number(item.variant_id)) && item.properties?._chef_stu_gift === 'seasoning-30';
  const qualifying = cart => cart.items.reduce((total, item) => total + (!qualifyingIds.includes(Number(item.product_id)) || marked(item) ? 0 : item.original_line_price), 0);
  const free = item => item.quantity === 1 && item.final_line_price === 0 && item.line_level_discount_allocations?.some(a => a.amount > 0);
  let busy = false, pending = 0, timer, cart, stock = [false, false], notice = '', permitCheckout = false;
  const panels = () => [...document.querySelectorAll('stu-gift-selector')];
  async function request(path, body) {
    const response = await fetch(root + path, {method: body ? 'POST' : 'GET', headers: {'Content-Type': 'application/json','Accept': 'application/json'}, ...(body ? {body: JSON.stringify(body)} : {cache: 'no-store'})});
    const result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error(result.description || words.error);
    return result;
  }
  function paint() {
    const selected = cart?.items.find(marked);
    const eligible = cart && cart.currency === 'USD' && qualifying(cart) >= 3000;
    document.querySelectorAll('.additional-checkout-buttons').forEach(element => {
      element.hidden = Boolean(selected) || busy || pending > 0;
      element.inert = Boolean(selected) || busy || pending > 0;
    });
    panels().forEach(panel => {
      panel.hidden = !cart || !cart.item_count;
      panel.setAttribute('aria-busy', String(busy || pending > 0));
      const select = panel.querySelector('[data-gift-select]');
      select.value = selected?.variant_id || '';
      select.disabled = busy || pending > 0 || !eligible || !stock.some(Boolean);
      ids.forEach((id, index) => {
        const option = select.querySelector(`[value="${id}"]`);
        option.disabled = !stock[index];
        option.textContent = words[index ? 'steak' : 'bagel'] + (stock[index] ? '' : ` (${words.sold_out})`);
      });
      let message = notice;
      if (busy || pending) message = words.busy;
      else if (!message && cart) {
        if (cart.currency !== 'USD') message = words.currency;
        else if (selected && free(selected)) message = words.confirmed;
        else if (!stock.some(Boolean)) message = words.unavailable;
        else if (!eligible) message = words.remaining.replace('__AMOUNT__', new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:'USD'}).format(Math.max(0,3000-qualifying(cart))/100));
        else message = words.ready;
      }
      panel.querySelector('[data-gift-status]').textContent = message;
    });
  }
  async function renderCart() {
    const sections = ['cart-drawer','cart-icon-bubble','cart-live-region-text'];
    const items = document.getElementById('main-cart-items');
    const footer = document.getElementById('main-cart-footer');
    if (items) sections.push(items.dataset.id);
    if (footer) sections.push(footer.dataset.id);
    const url = new URL(window.location.href);
    url.searchParams.set('sections', sections.join(','));
    const response = await fetch(url, {cache:'no-store'});
    if (!response.ok) throw new Error(words.error);
    const html = await response.json();
    const replace = (id, section, selector) => {
      if (!html[section]) return;
      const target = document.getElementById(id);
      const source = new DOMParser().parseFromString(html[section], 'text/html').querySelector(selector);
      if (target && source) (target.querySelector(selector) || target).innerHTML = source.innerHTML;
    };
    replace('CartDrawer', 'cart-drawer', '.drawer__inner');
    replace('cart-icon-bubble', 'cart-icon-bubble', '.shopify-section');
    replace('cart-live-region-text', 'cart-live-region-text', '.shopify-section');
    if (items) replace('main-cart-items', items.dataset.id, '.js-contents');
    if (footer) replace('main-cart-footer', footer.dataset.id, '.js-contents');
    document.querySelector('cart-drawer')?.classList.toggle('is-empty', cart.item_count === 0);
    document.querySelector('cart-items')?.classList.toggle('is-empty', cart.item_count === 0);
    footer?.classList.toggle('is-empty', cart.item_count === 0);
    document.querySelectorAll('cart-items, cart-drawer-items').forEach(element => {element.currentItemCount = cart.item_count;});
  }
  async function loadStock() {
    stock = await Promise.all(handles.map(async (handle,index) => {
      const product = await request(`products/${handle}.js`);
      return product.variants.some(v => Number(v.id) === ids[index] && v.available);
    }));
  }
  async function reconcile() {
    cart = await request('cart.js');
    await loadStock();
    const gifts = cart.items.filter(marked);
    const valid = cart.currency === 'USD' && qualifying(cart) >= 3000;
    const updates = {};
    gifts.forEach((item,index) => {
      if (!valid || index > 0 || !stock[ids.indexOf(Number(item.variant_id))] || !free(item)) updates[item.key] = 0;
    });
    if (Object.keys(updates).length) {
      cart = await request('cart/update.js', {updates});
      notice = words.removed;
      await renderCart();
    }
  }
  async function sync() {
    if (busy || pending) return false;
    busy = true; paint();
    try { await reconcile(); return true; }
    catch (error) { notice = words.error; return false; }
    finally { busy = false; paint(); }
  }
  function schedule() {
    clearTimeout(timer);
    if (!busy && !pending) timer = setTimeout(sync, 80);
  }
  async function choose(value) {
    if (busy || pending) return;
    busy = true; notice = ''; paint();
    try {
      cart = await request('cart.js');
      await loadStock();
      const updates = {};
      cart.items.filter(marked).forEach(item => { updates[item.key] = 0; });
      if (Object.keys(updates).length) cart = await request('cart/update.js', {updates});
      const id = Number(value);
      if (value && ids.includes(id) && cart.currency === 'USD' && qualifying(cart) >= 3000 && stock[ids.indexOf(id)]) {
        await request('cart/add.js', {items:[{id, quantity:1, properties:{_chef_stu_gift:'seasoning-30'}}]});
      }
      await reconcile();
      await renderCart();
    } catch (error) {
      notice = words.error;
      try { await reconcile(); await renderCart(); } catch (_) {}
    } finally {
      busy = false; paint();
      panels().find(p => p.offsetParent)?.querySelector('[data-gift-select]')?.focus();
    }
  }
  class StuGiftSelector extends HTMLElement {
    connectedCallback() {
      this.querySelector('[data-gift-select]').addEventListener('change', event => {event.stopPropagation(); choose(event.target.value);});
      paint(); schedule();
    }
  }
  window.StuGift = {
    beginCartChange() {pending++; notice = ''; paint();},
    endCartChange() {pending = Math.max(0,pending-1); schedule();},
    refresh: schedule
  };
  customElements.define('stu-gift-selector', StuGiftSelector);
  document.addEventListener('click', async event => {
    const checkout = event.target.closest('[name="checkout"]');
    if (!checkout || permitCheckout) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy || pending) return;
    if (await sync()) {permitCheckout = true; checkout.click(); permitCheckout = false;}
  }, true);
  document.addEventListener('submit', async event => {
    if (permitCheckout || event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    if (busy || pending) return;
    if (await sync()) {permitCheckout = true; event.target.requestSubmit(event.submitter); permitCheckout = false;}
  }, true);
  document.addEventListener('visibilitychange', () => {if (!document.hidden) schedule();});
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('click', event => {if (event.target.closest('#cart-icon-bubble')) schedule();});
})();
